import React, { Component } from "react";
import PropTypes from "prop-types";
import marked from "marked";

import { Spinner, ErrorMsg } from "..";

class Content extends Component {
  state = {
    content: {
      loading: false,
      error: false,
      errorMsg: "",
      data: null
    }
  };

  componentDidMount() {
    this.fetchContent(this.props.fileName);
  }

  componentWillReceiveProps(nextProps) {
    this.fetchContent(nextProps.fileName);
  }

  fetchContent = fileName => {
    const { internalAPI } = this.props;
    const self = this;

    //reset state
    self.setState(
      prevState => ({
        content: {
          ...prevState.content,
          loading: true,
          data: null,
          error: false,
          errorMsg: ""
        }
      }),
      () =>
        internalAPI
          .get(`/content?fileName=${fileName}`)
          .then(function(response) {
            self.setState(prevState => ({
              content: {
                ...prevState.content,
                loading: false,
                data: response.data
              }
            }));
          })
          .catch(error => {
            console.log("Error occurred in fetching content", error);
            self.setState(prevState => ({
              content: {
                ...prevState.content,
                loading: false,
                error: true,
                errorMsg: error.message
              }
            }));
          })
    );
  };

  render() {
    const { fileName } = this.props;
    const { content } = this.state;
    return (
      <div>
        <div
          style={{
            padding: "8px 16px",
            backgroundColor: "var(--secondaryColor)"
          }}
        >
          {content.loading && <Spinner message={`Loading file: ${fileName}`} />}

          {content.error && (
            <ErrorMsg
              message={"Error loading content"}
              description={content.errorMsg}
            />
          )}
          {content.data && (
            <div dangerouslySetInnerHTML={{ __html: marked(content.data) }} />
          )}
        </div>
      </div>
    );
  }
}

Content.propTypes = {
  internalAPI: PropTypes.func.isRequired,
  fileName: PropTypes.string.isRequired
};

export default Content;



// WEBPACK FOOTER //
// ./src/components/content/Content.jsx